import { render, staticRenderFns } from "./TfacIndividualStudentFileInfo.vue?vue&type=template&id=30830f66&scoped=true"
import script from "./TfacIndividualStudentFileInfo.vue?vue&type=script&lang=js"
export * from "./TfacIndividualStudentFileInfo.vue?vue&type=script&lang=js"
import style0 from "./TfacIndividualStudentFileInfo.vue?vue&type=style&index=0&id=30830f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30830f66",
  null
  
)

export default component.exports